.center {
	width: 100%;
	height: 100%;

	justify-content: center;
	flex-wrap: wrap;
	gap: 1rem;
	padding: 2rem;
	display: flex;
}
.center::-webkit-scrollbar {
	position: absolute;
	width: 10px;
}
.center::-webkit-scrollbar-track {
	background-color: var(--depth1);
	padding: 0.2rem;
	border-radius: var(--rounded);
}
.center::-webkit-scrollbar-thumb {
	background-color: var(--secondary);
	border-radius: var(--rounded);
}
@media only screen and (max-width: 900px) {
	.center {
		flex-wrap: wrap;
		justify-content: center;
		padding: 1rem;

		align-items: center;
	}
}
